module.exports = __webpack_public_path__ + "static/media/chatBubble.87fb22fd.svg";